import { render, staticRenderFns } from "./Rewards.vue?vue&type=template&id=08efb2ca&scoped=true&"
import script from "./Rewards.vue?vue&type=script&lang=js&"
export * from "./Rewards.vue?vue&type=script&lang=js&"
import style0 from "./Rewards.vue?vue&type=style&index=0&id=08efb2ca&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08efb2ca",
  null
  
)

component.options.__file = "Rewards.vue"
export default component.exports